import React, { FC } from 'react';

import {
  ArrowDownloadRegular,
  CheckmarkRegular,
  DeleteRegular,
  MoreVerticalRegular,
} from '@fluentui/react-icons';
import { Divider } from '@fluentui/react-components';
import { Attachment } from '../../Attachment/Attachment';
import { Button } from '../../Button/Button';
import { Popup } from '../../Popup/Popup';

import { useTranslation } from 'react-i18next';
import { getEditableDataType } from '../Assignments.utils';
import './AssignmentResourceItem.module.css';

export interface AssignmentResourceItemProps {
  displayName: string;
  id: string;
  distributeForStudentWork: boolean;
  distributeHidden?: boolean;
  editMode: boolean;
  handleDistributeChange?(distribute: boolean): void;
  handleDeleteResource?(resourceId: string): void;
  handleOpen?(): void;
  isLink?: boolean;
  handleDownload?(): void;
}

export const AssignmentResourceItem: FC<
  AssignmentResourceItemProps
> = props => {
  const { t } = useTranslation();
  const {
    id,
    displayName,
    distributeForStudentWork,
    editMode,
    distributeHidden,
    handleDeleteResource,
    handleDownload,
    handleOpen,
    isLink,
  } = props;

  const downloadButton = (
    <Button
      tabIndex={0}
      className="assigmentRessourceMenuItems"
      appearance="transparent"
      onClick={() => handleDownload?.()}
      icon={<ArrowDownloadRegular />}
    >
      {t('assignment_resource_download', { defaultValue: 'Herunterladen' })}
    </Button>
  );

  const openOnlineButton = (
    <Button
      tabIndex={0}
      appearance="transparent"
      className="assigmentRessourceMenuItems"
      onClick={() => {
        handleOpen?.();
      }}
      icon={getEditableDataType(displayName, isLink ?? false) as JSX.Element}
    >
      {t('assignments:resource_open_online', { defaultValue: 'Online öffnen' })}
    </Button>
  );

  const deleteButton = (
    <Button
      tabIndex={0}
      appearance="transparent"
      className="assigmentRessourceMenuItems"
      onClick={() => {
        handleDeleteResource?.(id);
      }}
      icon={<DeleteRegular />}
    >
      {t('assignments:resource_delete', { defaultValue: 'Löschen' })}
    </Button>
  );

  const distributeText = distributeForStudentWork
    ? t('assignments:distributeForStudentWork', { defaultValue: 'Schüler bearbeiten ihre eigene Kopie' })
    : t('assignments:distributeForStudentWork_not', { defaultValue: 'Schüler können nicht bearbeiten' });
  return (
    <div className="flex">
      <Attachment
        icon={getEditableDataType(displayName, isLink ?? false)}
        header={displayName}
        description={!distributeHidden ? distributeText : undefined}
        action={
          <Popup
            trigger={
              <Button
                appearance="transparent"
                icon={<MoreVerticalRegular />}
                tabIndex={0}
              />
            }
            content={
              editMode ? (
                <div className="flex flex-col gap-2" tabIndex={0}>
                  {!isLink && distributeForStudentWork && !distributeHidden && (
                    <div className="flex gap-2 pointer">
                      <CheckmarkRegular />
                      <span tabIndex={0}>{distributeText}</span>
                    </div>
                  )}
                  {!isLink && (
                    <Divider className="assigmentRessourceMenuItems" />
                  )}
                  {!isLink && downloadButton}

                  {openOnlineButton}
                  <Divider />
                  {deleteButton}
                </div>
              ) : (
                <div className="flex flex-col gap-2">
                  {!isLink && downloadButton}
                  {!isLink && (
                    <Divider className="assigmentRessourceMenuItems" />
                  )}
                  {openOnlineButton}
                </div>
              )
            }
          />
        }
      />
    </div>
  );
};
